module.exports = __webpack_public_path__ + "img/exam_jan_2025_o5kjkyv4.27903869.jpg";